export const domain = "https://minsky.uk.auth0.com";
export const clientId = "9ac28D1CkdTYwHjmRjNHHC2kWmW9hFl4";
export const audience = "https://minsky.uk.auth0.com/api/v2/";
export const scopes = "openid profile email";
export const redirectUri = "https://minskyassistantuat.neurobridge.tech";
